import { ChangeDetectionStrategy, Component, Input, OnInit, ViewChild } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import {
    BadMoodPass,
    Reactions,
    ReactionsComponent,
    Threads,
    TimelineItem,
    TimelineItemType
} from "@teammood/timeline";
import { ThreadsComponent } from "../../../threads/threads.component";
import { UserInfos } from "../../../../shared/ui/username-icon/user-infos.type";
import { ManagerPanelComponent } from "../../manager-panel/manager-panel.component";

@Component({
    selector: "tm-bad-mood-pass",
    templateUrl: "./bad-mood-pass.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TranslateModule,
        ReactionsComponent,
        ThreadsComponent,
        ManagerPanelComponent
    ]
})
export class BadMoodPassComponent implements OnInit {
    @Input({required: true})
    badMoodPass: BadMoodPass

    @Input() isOdd: boolean;
    
    @Input() userInfos: UserInfos;

    @ViewChild('threadsComponent')
    private threadsComponent: ThreadsComponent;

    protected showThreads: boolean = true;

    protected threadsCount: number = 0;
    protected careCount: number = 0;

    ngOnInit() {
        this.threadsCount = this.badMoodPass?.threads?.length;
        this.careCount = this.badMoodPass?.reactions?.filter(reaction => reaction.id == "care").length;
    }

    protected onThreadsUpdated(timelineItem: TimelineItem & Threads): void {
        if (timelineItem.itemType == "badMoodPassItem"){
            this.badMoodPass = timelineItem as BadMoodPass;
        }
    }

    protected onReacted(timelineItem: {id: string, itemType: TimelineItemType} & Reactions): void {
        if (timelineItem.itemType == "badMoodPassItem"){
            this.badMoodPass = timelineItem as BadMoodPass;
        }
    }

    protected toggleThreads() {
        this.showThreads = !this.showThreads;
    }

    protected discuss() {
        if (this.threadsComponent) {
            this.threadsComponent.discuss = true;
        }
    }

    // fix a race condition by using a function
    getThreadsComponent: () => ThreadsComponent = () => this.threadsComponent;
}